import React from 'react';
import {
  Grid,
  Button,
} from '@material-ui/core'

import { Helmet } from 'react-helmet';

import ReactResizeDetector from 'react-resize-detector';

import CoupangPartners from '../../components/CoupangPartners/CoupangPartners';

import APIServer from '../../config/server.conf.json';

import logo from "assets/img/logo_coupang.png";

export default class Coupang extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      twitter_url_string: 'https://twitter.com/TheAcademy/status/1226730862735003650\nhttps://twitter.com/TheAcademy/status/1226719645849145344?s=20',
      twitter_url: [],
      twitter_result: [],
      playlist: []
    }
  }

  handleGetVideo = () => {
    let twitter_url = this.state.twitter_url_string.split('\n');

    fetch(`${APIServer.baseUrl}/api/v1/twitter/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: twitter_url.map(e => (
          /(https:\/\/.*twitter\.com\/.*\/status\/[^?|]+)/.exec(e)[1]
        ))
      })
    })
      .then(res => res.json())
      .then(res => {
        this.setState({
          twitter_url: twitter_url,
          twitter_result: res.data,
          playlist: res.data.filter(e => e.media.length > 0).map(e => ({ thumbnail: e.media[0].media_url, url: e.media[0].video_info[0].url, raw: e }))
        });
      })
  }

  render() {
    return (
      <Grid container spacing={5}>
        <Helmet
          title="쿠팡 바로가기"
          meta={[
            { name: "description", content: "쿠팡 바로가기" },
            { name: "keywords", content: "toolbox, tbx, 툴박스, twitter, twitter movie, twitter movie download, twitter mp4, twitter mp4 download, 트위터, 트위터 영상, 트위터 동영상, 트위터 영상 다운로드, 트위터 동영상 다운로드, 쿠팡, 쿠팡 바로가기" },
            { property: "og:title", content: "쿠팡 바로가기 - TBX" },
            { property: "og:description", content: "쿠팡 바로가기 - TBX" },
            { property: "og:title", content: "쿠팡 바로가기 - TBX" },
          ]}
        />
        <Grid item xs={12}>
          <ReactResizeDetector handleWidth handleHeight>
            {({ width, height }) => <CoupangPartners width={width} height={height} />}
          </ReactResizeDetector>
        </Grid>
        <Grid item xs={12} lg={10}>
          <Grid container spacing={2} fixed>
            <Button component="a" variant='outlined' color='default' size='large' style={{ height: '300px', width: '100%' }} href="https://coupa.ng/bCSWmc">
              <img src={logo} />
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}